export default __webpack_public_path__ + "static/media/bnb-mlt.3a99a75a.svg";